'use es6';

import { defaultTooltipOptions } from '../../../highcharts/options/tooltipOptions';
import { getTooltipFormatter as getLegacyTooltipFormatter } from './tooltips/legacyTooltip';
import { getTooltipFormatter as getPointTooltipFormatter } from './tooltips/pointTooltip';
import { MarkTypes } from '../xyRecords';
const TOOLTIP_FORMATTERS = {
  point: getPointTooltipFormatter,
  legacy: getLegacyTooltipFormatter
};
export const getTooltipOptions = ({
  chart,
  layers
}) => {
  const primaryLayer = layers.first();
  const markType = primaryLayer.getIn(['mark', 'type']);
  const formatter = [MarkTypes.scatter, MarkTypes.bubble].includes(markType) ? TOOLTIP_FORMATTERS.point({
    chart,
    layers
  }) : TOOLTIP_FORMATTERS.legacy({
    chart,
    layers
  });
  return Object.assign({}, defaultTooltipOptions, {
    formatter
  });
};